import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { useSelector } from 'react-redux';
import hash from 'object-hash';
import { cloneDeep, get, isEmpty, uniq, uniqueId, without } from 'lodash';
import moment from 'moment-timezone';
import RecapADD from 'containers/common/LegalProceedings/JudgementAdd/Recap';
import { Listings } from 'containers/AppContainer/typings';
import {
  IJudgementAdd,
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import DropDownDecisionMenu from 'components/SahamDropDown/DropDownDecisionMenu';
import { JudgementAddDecisionStyle } from 'containers/CourtManagerLegalProceedings/styled-components';
import recapManagerMessages from 'containers/RecapManagerPage/messages';
import { arrayTranslate, translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import RefusalDialog from 'containers/CourtManagerLegalProceedings/JudgementAdd/Dialogs/RefusalDialog';
import { EMPTY_DETAIL, JUDGEMENT } from 'containers/data-structure';
import { shouldDisplayAddDecisionMenu } from 'containers/CourtManagerLegalProceedings/JudgementAdd/utils';
import {
  CURRENT_INDEX_STATE,
  DIALOGS,
  DIALOGS_STATE,
  DRAWERS,
  DRAWERS_STATE,
} from 'containers/CourtManagerLegalProceedings/JudgementAdd/constants';
import {
  IndexState,
  IOpenState,
} from 'containers/CourtManagerLegalProceedings/JudgementAdd/typings';
import ValidationDialog from 'containers/CourtManagerLegalProceedings/JudgementAdd/Dialogs/ValidationDialog';
import ProcedureInformationDrawer from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/ProcedureInformationDrawer';
import CivilPartyDrawer from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/CivilPartyDrawer';
import JudgementAddPronouncingDrawer from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/JudgementAddPronouncingDrawer';
import { Idetails } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/typings';
import { CivilParty } from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/constants';
import {
  CorporealDocument,
  JudgementADDDocumentType,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { getPartiesIds } from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/utils';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import withLoading from 'containers/AppContainer/withLoading';
import { LOADERS } from 'containers/AppContainer/Loader/constants';
import { Container } from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/styled-component';
import { STATUS_VALIDATED } from 'containers/LawyerFeeNote/constants';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import {
  getVehicles,
  getVictims,
  validationCourtFileNumber,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import { detailsValidator } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/form-validation';
import { CivilParty as ICivilParty } from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/constants';
import {
  displayErrorText,
  validateFormFields,
} from 'containers/services/validateForm';
import FormsADD from 'containers/LawyerLegalProceedingsPage/judgementAdd/FormsADD';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';
import {
  EMPTY_SUPPORT_DOC,
  SUPPORT_DOC_ID,
  SUPPORT_DOC_JUDGEMENT_ADD_ID,
} from 'containers/LawyerRecapPage/constants';
import { addDaysToDate } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/utils';
import { DATE_FORMAT } from 'constants/global';
import { VictimType } from 'typings/globalTypes';
export interface CourtManagerRecapAddProps {
  intl: IntlShape;
  listings: Listings;
  judgementAdd: IJudgementAdd;
  claimId: number;
  claimNumber: string;
  requestMakeJudgementAddDecision: Function;
  victims: VictimType[];
  vehicules: Vehicule[];
  policyInfo: any;
  claim: any;
  isCivilProceeding: boolean;
  stakeholders: any;
  assignedLawyer: any;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  judiciaryProcessId: number;
  isManager: boolean;
  requestMakeJudgementAddDocumentDecision: Function;
  loaders: any;
  currentJudiciaryProcess: any;
  requestCreateJudgementAdd: Function;
  lossDate: string;
  requestGetJudgementAdd?: Function;
  requestCreateMultipleJudgementAdd?: Function;
  expertReport: ExpertReportType;
  judgementOnMerits: JudgementOnMeritsType;
  currentIndexTabManager: any;
  documentId: string;
  requestAddSupportDocument: Function;
  requestCivilPartySupportDocument: Function;
  setDocumentId: Function;
  setDocument: Function;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  feeNotes: any;
  setOpenFeeNoteDialog: Function;
  setIsButtonRedirect: Function;
  isConsultation: boolean;
  requestCreateIncomeCertificate: Function;
  requestUpdateIncomeCertificate: Function;
  requestMakeDecisionIncomeCertificate: Function;
  requestMakeDecisionSupportDocument?: Function;
  riskKey: string;
  imagineDocuments: any;
  requestGetDahirAmount: Function;
  dahirAmount: [];
  requestGetDocByDocumentumId: Function;
}

export const CourtManagerRecapAdd: React.FC<CourtManagerRecapAddProps> = (
  props,
): JSX.Element => {
  const [details, setDetails] = useState<Idetails>(cloneDeep(EMPTY_DETAIL));
  const [judgementAddDocuments, setJudgementAddDocuments] = useState<
    JudgementADDDocumentType[]
  >([]);
  const claimRecap = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap'], []),
  );
  const [judgementAddHash, setJudgementAddHash] = useState<string>('');
  useEffect(() => {
    setJudgementAdd(cloneDeep(props.judgementAdd));
    setJudgementAddHash(hash(props.judgementAdd));

    setProcedureInformations(
      cloneDeep(get(props.judgementAdd, 'judgementAdd', {})),
    );
  }, [
    props.judgementAdd,
    props.currentIndexTabManager,
    props.currentJudiciaryProcess,
    props.riskKey,
  ]);
  useEffect(() => {
    if (!isEmpty(props.victims)) {
      const victimkeys = [
        ...without(
          uniq(
            get(props, 'victims', [])
              .filter((v: any) => v['injuryPostKey'] !== '2')
              .map((v: any) => v.victimKey),
          ),
          null,
          '',
        ),
      ];
      const deceasedVictimkeys = [
        ...without(
          uniq(
            get(props, 'victims', [])
              .filter((v: any) => v['injuryPostKey'] === '2')
              .map((v: any) => v.victimKey),
          ),
          null,
          '',
        ),
      ];
      props.requestGetDahirAmount(victimkeys, deceasedVictimkeys);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.victims, props.riskKey]);

  const [dropDown, setDropDown] = useState<null | HTMLElement>(null);
  const [isDialogOpen, setIsDialogOpen] = useState<IOpenState>({
    ...DIALOGS_STATE,
  });
  const [isDrawerOpen, setIsDrawerOpen] = useState<IOpenState>({
    ...DRAWERS_STATE,
  });
  const [currentIndex, setCurrentIndex] = useState<IndexState>(
    CURRENT_INDEX_STATE,
  );

  const [procedureInformations, setProcedureInformations] = useState<
    Idetails | {}
  >({});
  const [civilDocumentsVictims, setCivilDocumentsVictims] = useState<
    Set<number>
  >(new Set());

  const [judgementAddExpertises, setJudgementAddExpertises] = useState<
    JudgementADDDocumentType[] | []
  >([]);
  const [
    validateJudgementAddProcedure,
    setValidateJudgementAddProcedure,
  ] = useState<any>();
  const [judgementAdd, setJudgementAdd] = useState<IJudgementAdd | {}>({});
  const [civilPartyDocuments, setCivilPartyDocuments] = useState<ICivilParty[]>(
    [],
  );

  const [messageError, setMessageError] = useState<any>({});
  const [
    processInformationValidation,
    setProcessInformationValidation,
  ] = useState<any>({});
  const [
    areProcedureInformationValidated,
    setAreProcedureInformationValidated,
  ] = useState<boolean>(false);
  const [isCivilPartyPresent, setIsCivilPartyPresent] = useState<boolean>(
    false,
  );
  const [supportDocument, setSupportDocument] = useState({
    ...EMPTY_SUPPORT_DOC,
  });
  const [supportDocumentAdd, setSupportDocumentAdd] = useState({
    ...EMPTY_SUPPORT_DOC,
  });

  useEffect(() => {
    const procedureInformationValidation = detailsValidator(details);
    setProcessInformationValidation(procedureInformationValidation);
    const translateArrayErrorMessages = arrayTranslate(
      props.intl.formatMessage,
    );
    const { message } = displayErrorText(
      procedureInformationValidation,
      translateArrayErrorMessages(procedureInformationValidation, true),
    );
    setMessageError(message);
    setAreProcedureInformationValidated(
      !!validateFormFields(procedureInformationValidation) &&
        !(
          new Date(addDaysToDate(props.lossDate || '', 1) || '') >
          new Date(get(details, 'hearingDate') || '')
        ) &&
        !!validationCourtFileNumber(details.courtFile) &&
        moment(get(details, 'hearingDate')).format(DATE_FORMAT) !=
          'Invalid date',
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details]);
  useEffect(() => {
    setIsCivilPartyPresent(!isEmpty(civilPartyDocuments));
    setValidateJudgementAddProcedure(
      props.isCivilProceeding
        ? areProcedureInformationValidated
        : areProcedureInformationValidated && !isEmpty(civilPartyDocuments),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [civilPartyDocuments, details, areProcedureInformationValidated]);
  useEffect(() => {
    const _civilDocuments = get(props.judgementAdd, 'civilDocuments', []);
    const vicIds = getPartiesIds(
      get(_civilDocuments[currentIndex[DRAWERS.CIVIL_PARTY]], 'victims', []),
    );
    setCivilDocumentsVictims(new Set(vicIds));
  }, [currentIndex, props.judgementAdd]);

  useEffect(() => {
    setJudgementAddExpertises(
      get(props.judgementAdd, 'judgementAddDocuments', []),
    );
  }, [props.judgementAdd, props.judiciaryProcessId]);

  const handleIsDialogOpen = (
    dialog: string,
    value?: boolean,
    toUpdate: boolean = false,
    civilParty: boolean = false,
  ) => () => {
    setIsDialogOpen({
      ...isDialogOpen,
      [dialog]: !!value,
      toUpdate,
      civilParty,
    });
  };

  const handleIsDrawerOpen = (drawer: string) => (index?: number) => (
    event?: React.ChangeEvent<{}>,
  ) => {
    event && event.stopPropagation();

    const previousState = isDrawerOpen[drawer];

    setIsDrawerOpen({
      ...isDrawerOpen,
      [drawer]: !previousState,
    });

    setCurrentIndex({ ...currentIndex, [drawer]: index as number });
  };
  const customJudgementAddSetter = (
    fieldName: string,
    fieldToSet: Idetails | CivilParty[] | JudgementADDDocumentType[],
  ) => {
    setJudgementAdd({
      ...judgementAdd,
      [fieldName]: fieldToSet,
    });
  };

  const lawyer: string = get(judgementAdd, 'creator');

  const dropDownMenuElements = [
    {
      title: translate(messages.courtManagerJudgementValidate, props),
      action: handleIsDialogOpen(DIALOGS.VALIDATION, true),
    },
    {
      title: translate(messages.courtManagerJudgementRefuse, props),
      action: handleIsDialogOpen(DIALOGS.REFUSAL, true),
    },
  ];

  const setDocumentAdd = (document: CorporealDocument) => {
    if (SUPPORT_DOC_JUDGEMENT_ADD_ID === String(props.documentId)) {
      setSupportDocumentAdd(document);
      props.requestAddSupportDocument &&
        props.requestAddSupportDocument({
          ...document,
          isLawyer: false,
          status: STATUS_VALIDATED,
          judgementAddId: get(props.judgementAdd, ['judgementAdd', 'id']),
          claimId: props.claimId,
          claimNumber: props.claimNumber,
        });
      props.resetUploadedDocument();
    }
  };

  const setDocument = (document: CorporealDocument) => {
    if (SUPPORT_DOC_ID === props.documentId) {
      setSupportDocument(document);
      props.requestCivilPartySupportDocument &&
        props.requestCivilPartySupportDocument({
          ...document,
          isLawyer: false,
          judgementAddId: get(props.judgementAdd, ['judgementAdd', 'id']),
          claimId: props.claimId,
          claimNumber: props.claimNumber,
          status: STATUS_VALIDATED,
        });
      props.resetUploadedDocument();
    }
  };
  return (
    <Container>
      {shouldDisplayAddDecisionMenu(get(judgementAdd, JUDGEMENT.STATUS)) &&
        !props.isConsultation &&
        (userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) ||
          (userPrivileges.userHasPrivilege(
            PRIVILEGES.ISCOURTMONITORINGMANAGER,
          ) &&
            userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER))) && (
          <JudgementAddDecisionStyle>
            <DropDownDecisionMenu
              setDropDown={setDropDown}
              dropDown={dropDown}
              label={translate(
                recapManagerMessages.managerRecapPageDecisionButton,
                props,
              )}
              menuElements={dropDownMenuElements}
            />
          </JudgementAddDecisionStyle>
        )}

      {!isEmpty(judgementAdd) ? (
        <RecapADD
          listings={props.listings}
          readOnly={props.isConsultation}
          judgementAdd={judgementAdd}
          judgementAddStore={props.judgementAdd}
          handleOnEditCivilPartyClick={handleIsDrawerOpen(DRAWERS.CIVIL_PARTY)}
          handleOnEditJudgementAddClick={handleIsDrawerOpen(
            DRAWERS.JUDGEMENT_ADD,
          )}
          handleOnEditProcedureInfoClick={handleIsDrawerOpen(
            DRAWERS.PROCEDURE_INFORMATION,
          )}
          currentJudiciaryProcess={props.currentJudiciaryProcess}
          isCivilProceeding={props.isCivilProceeding}
          stakeholders={props.stakeholders}
          assignedLawyer={props.assignedLawyer}
          victims={props.victims}
          vehicules={props.vehicules}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          resetUploadedDocument={props.resetUploadedDocument}
          claimNumber={props.claimNumber}
          judiciaryProcessId={props.judiciaryProcessId}
          policyInfo={props.policyInfo}
          isManager={
            !props.isConsultation &&
            userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)
          }
          requestMakeJudgementAddDocumentDecision={
            props.requestMakeJudgementAddDocumentDecision
          }
          setJudgementAdd={setJudgementAdd}
          isAssignedLawyer={!props.isConsultation}
          isCreator={!props.isConsultation}
          requestGetJudgementAdd={props.requestGetJudgementAdd}
          requestCreateMultipleJudgementAdd={
            props.requestCreateMultipleJudgementAdd
          }
          expertReport={props.expertReport}
          judgementOnMerits={props.judgementOnMerits}
          document={supportDocument}
          setDocument={setDocument}
          documentAdd={supportDocumentAdd}
          setDocumentAdd={setDocumentAdd}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          handleIsDialogOpen={handleIsDialogOpen}
          sagisVictimInfo={props.sagisVictimInfo}
          sagisOpposingParties={props.sagisOpposingParties}
          setIsButtonRedirect={props.setIsButtonRedirect}
          feeNotes={props.feeNotes}
          setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
          requestCreateIncomeCertificate={props.requestCreateIncomeCertificate}
          requestUpdateIncomeCertificate={props.requestUpdateIncomeCertificate}
          requestMakeDecisionIncomeCertificate={
            props.requestMakeDecisionIncomeCertificate
          }
          isConsultation={props.isConsultation}
          riskKey={props.riskKey}
          requestMakeDecisionSupportDocument={
            props.requestMakeDecisionSupportDocument
          }
          imagineDocuments={props.imagineDocuments}
          dahirAmount={props.dahirAmount}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      ) : (
        featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) &&
        !props.isConsultation &&
        ((isEmpty(judgementAdd) &&
          !userPrivileges.userHasPrivilege(
            PRIVILEGES.ISCOURTMONITORINGMANAGER,
          )) ||
          (isEmpty(judgementAdd) &&
            !props.isCivilProceeding &&
            userPrivileges.userHasPrivilege(
              PRIVILEGES.ISCOURTMONITORINGMANAGER,
            ))) && (
          <FormsADD
            judiciaryProcessId={props.judiciaryProcessId}
            victims={getVictims(
              props.isCivilProceeding,
              props.currentJudiciaryProcess,
              props.judgementAdd,
              props.victims,
              claimRecap,
            )}
            vehicules={getVehicles(
              props.isCivilProceeding,
              props.currentJudiciaryProcess,
              props.judgementAdd,
              props.vehicules,
            )}
            listings={props.listings}
            isCivilProceeding={props.isCivilProceeding}
            claimId={props.claimId}
            claimNumber={props.claimNumber}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            resetUploadedDocument={props.resetUploadedDocument}
            requestCreateJudgementAdd={props.requestCreateJudgementAdd}
            details={details}
            judgementAddDocuments={judgementAddDocuments}
            civilPartyDocuments={civilPartyDocuments}
            setDetails={setDetails}
            setJudgementAddDocuments={setJudgementAddDocuments}
            setCivilPartyDocuments={setCivilPartyDocuments}
            canValidateJudgementAddProcedure={validateJudgementAddProcedure}
            canStartCivilParty={areProcedureInformationValidated}
            canStartJudgementAdd={isCivilPartyPresent}
            policyInfo={props.policyInfo}
            processInformationValidation={processInformationValidation}
            messageError={messageError}
            lossDate={props.lossDate}
            currentJudiciaryProcess={props.currentJudiciaryProcess}
            isManager={userPrivileges.userHasPrivilege(
              PRIVILEGES.ISCOURTMANAGER,
            )}
            sagisVictimInfo={props.sagisVictimInfo}
            sagisOpposingParties={props.sagisOpposingParties}
            setIsButtonRedirect={props.setIsButtonRedirect}
            feeNotes={props.feeNotes}
            setDocumentId={props.setDocumentId}
            documentId={props.documentId}
            requestCreateIncomeCertificate={
              props.requestCreateIncomeCertificate
            }
            requestUpdateIncomeCertificate={
              props.requestUpdateIncomeCertificate
            }
            requestMakeDecisionIncomeCertificate={
              props.requestMakeDecisionIncomeCertificate
            }
            isConsultation={props.isConsultation}
            riskKey={props.riskKey}
            imagineDocuments={props.imagineDocuments}
            dahirAmount={props.dahirAmount}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
        )
      )}
      <ValidationDialog
        open={isDialogOpen[DIALOGS.VALIDATION]}
        handleClose={handleIsDialogOpen(DIALOGS.VALIDATION)}
        requestMakeJudgementAddDecision={props.requestMakeJudgementAddDecision}
        lawyer={lawyer}
        claimId={props.claimId}
        claimNumber={props.claimNumber}
        judgementAdd={judgementAdd}
        judgementAddHash={judgementAddHash}
        judgementAddDocumentsHash={hash(
          get(props.judgementAdd, 'judgementAddDocuments', []),
        )}
        listing={props.listings}
        policyInfo={props.policyInfo}
        claim={props.claim}
        expertReport={props.expertReport}
        judgementOnMerits={props.judgementOnMerits}
        toUpdate={get(isDialogOpen, 'toUpdate', false)}
        civilParty={get(isDialogOpen, 'civilParty', false)}
        setIsButtonRedirect={props.setIsButtonRedirect}
        setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
      />
      <RefusalDialog
        isRefuseDialogOpen={isDialogOpen[DIALOGS.REFUSAL]}
        handleCancel={handleIsDialogOpen(DIALOGS.REFUSAL)}
        requestMakeJudgementAddDecision={props.requestMakeJudgementAddDecision}
        claimId={props.claimId}
        claimNumber={props.claimNumber}
        lawyer={lawyer}
        judgementAdd={judgementAdd}
        listing={props.listings}
        judgementId={get(props.judgementAdd, 'id')}
        policyInfo={props.policyInfo}
        claim={props.claim}
        setIsButtonRedirect={props.setIsButtonRedirect}
        setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
      />
      <ProcedureInformationDrawer
        open={isDrawerOpen[DRAWERS.PROCEDURE_INFORMATION]}
        handleToggleDrawer={handleIsDrawerOpen(DRAWERS.PROCEDURE_INFORMATION)()}
        details={procedureInformations as Idetails}
        setDetails={setProcedureInformations}
        listings={props.listings}
        setJudgementAdd={customJudgementAddSetter}
        vehicules={props.vehicules}
        lossDate={get(props, 'claim.lossDate')}
        sagisOpposingParties={props.sagisOpposingParties}
        currentJudiciaryProcess={props.currentJudiciaryProcess}
      />
      {!props.isCivilProceeding && (
        <CivilPartyDrawer
          key={uniqueId('civil-doc-drawer')}
          open={isDrawerOpen[DRAWERS.CIVIL_PARTY]}
          handleToggleDrawer={handleIsDrawerOpen(DRAWERS.CIVIL_PARTY)(
            currentIndex[DRAWERS.CIVIL_PARTY],
          )}
          civilDocuments={get(props.judgementAdd, 'civilDocuments', [])}
          index={currentIndex[DRAWERS.CIVIL_PARTY]}
          setJudgementAdd={customJudgementAddSetter}
          victims={props.victims}
          civilDocumentsVictims={civilDocumentsVictims}
          setCivilDocumentsVictims={setCivilDocumentsVictims}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          resetUploadedDocuments={props.resetUploadedDocument}
          setDocumentId={() => {}}
          document={{}}
          setDocument={() => {}}
          documentId={null}
          sagisVictimInfo={props.sagisVictimInfo}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      )}
      <JudgementAddPronouncingDrawer
        open={isDrawerOpen[DRAWERS.JUDGEMENT_ADD]}
        handleToggleDrawer={handleIsDrawerOpen(DRAWERS.JUDGEMENT_ADD)()}
        victims={props.victims}
        vehicules={props.vehicules}
        setJudgementAdd={customJudgementAddSetter}
        index={currentIndex[DRAWERS.JUDGEMENT_ADD]}
        judgementAddExpertises={
          judgementAddExpertises as JudgementADDDocumentType[]
        }
        setJudgementAddExpertises={setJudgementAddExpertises}
        listings={props.listings}
        hearingDate={get(procedureInformations, 'hearingDate')}
        uploadDocument={props.uploadDocument}
        uploadedDocument={props.uploadedDocument}
        resetUploadedDocument={props.resetUploadedDocument}
        judgementAddDocumentsStore={get(
          props.judgementAdd,
          'judgementAddDocuments',
          [],
        )}
        sagisVictimInfo={props.sagisVictimInfo}
        sagisOpposingParties={props.sagisOpposingParties}
        judgementOnMerits={props.judgementOnMerits}
      />
    </Container>
  );
};

export default withLoading(injectIntl(CourtManagerRecapAdd), [
  LOADERS.JUDGEMENT_ADD,
]);
